
//the login page actions
export const handleLoginPage = ( alignment ) => {
    return {
        type: 'HANDLE_PAGE_TOGGLE' , 
        payload: {
            alignment: alignment
        }
    }
};

//login page values
export const captureAdminRadioValue = (adminValue) => {
    return {
        type: 'ADMIN_SWITCH_VALUE',
        payload: {
            adminValue: adminValue
        }
    }
};

export const captureUserRadioValue = (userValue) => {
    return {
        type: 'USER_SWITCH_VALUE',
        payload: {
            userValue: userValue
        }
    }
};

export const captureSuperRadioValue = (userValue) => {
    return {
        type: 'SUPER_SWITCH_VALUE',
        payload: {
            userValue: userValue
        }
    }
};

export const logoutClicked = () => {
    return {
        type: 'LOGOUT'
    }
};

//for storing user name
export const handleUserName = (userName) => {
    return {
        type: 'HANDLE_USER_NAME',
        payload: {
            userName: userName
        }
    }
};

//for storing theme
export const handleTheme = (theme) => {
    return {
        type: 'HANDLE_THEME',
        payload: {
            theme: theme
        }
    }
};

//for storing theme
export const handleText = (text) => {
    return {
        type: 'HANDLE_TEXT',
        payload: {
            text: text
        }
    }
};

//To set temporary buyer and seller
export const fullName = (fullName) => {
    return {
        type: 'HANDLE_FULL_NAME',
        payload: {
            fullName: fullName
        }
    }
};


//for storing user name
export const handleToken = (token) => {
    return {
        type: 'HANDLE_TOKEN',
        payload: {
            token: token
        }
    }
};



//for storing code
export const handleCode = (code) => {
    return {
        type: 'HANDLE_CODE',
        payload: {
            code: code
        }
    }
};



//for storing code
export const handleDisplay = (display) => {
    return {
        type: 'HANDLE_DISPLAY',
        payload: {
            display: display
        }
    }
};






//for storing code
export const handleNoti = (noti) => {
    return {
        type: 'HANDLE_NOTI',
        payload: {
            noti: noti
        }
    }
};
